import React from "react";
import NavigationBar from "../../Components/NavigationBar/NavigationBar";
import Home from "../../Views/User/Home/Home";
import {
  Routes,
  Route,
  Link,
  Navigate,
} from "react-router-dom";
import AboutUs from "../../Views/User/AboutUs/AboutUs";
import ContactUs from "../../Views/User/ContactUs";
import Gallery from "../../Views/User/Gallery";
import OurTeam from "../../Views/User/OurTeam";
import Listing from "../../Views/User/Listing";
import Login from "../../Views/User/Login/Login";
import Register from "../../Views/User/Register/Register";
import Footer from "../../Components/Footer";
import UnitReservationForm from '../../Views/User/UnitReservationForm/UnitReservationForm';
import UnitPayment from '../../Views/UnitPayment';


function User() {
  return (
    <div>
      {/* <NavigationBar /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/our-team" element={<OurTeam />} />
        <Route path="/listinings" element={<Listing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        {/* <Route path="/unit-reservation/:unitId" element={<UnitReservationForm />} />
        <Route path="/unit-payment/:unitId" element={<UnitPayment />} /> */}
        <Route path="/not-found" element={<h1>Not Found</h1>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default User;
